// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3htyB","options":"AnswerScale_options__UwzFC","selected":"AnswerScale_selected__33P3l"};